<template>
  <div>

    <v-tabs class="list-tabs" slider-color="white" flat v-if="!isLoading">
      <v-tab>
        <strong>Requerimentos</strong>
      </v-tab>
      <v-tab>
        <strong class="mr-2">Intimações</strong>
        <v-icon color="red" v-if="subpoenas">mdi-alert-circle</v-icon>
      </v-tab>
      <v-tab>
        <strong class="mr-2">Auto de Infração</strong>
        <v-icon color="red" v-if="infractions">mdi-alert-circle</v-icon>
      </v-tab>
      <v-tab>
        <strong class="mr-2">Defesa</strong>
        <v-icon color="red" v-if="infractionNotices">mdi-alert-circle</v-icon>
      </v-tab>
      <v-tab>
        <strong class="mr-2">Boletos</strong>
        <v-icon color="red" v-if="paymentSlips">mdi-alert-circle</v-icon>
      </v-tab>

      <!-- Requerimentos -->
      <v-tab-item>
        <v-card class="elevation-10">
          <applications-header
              :applications="all"
              :activeStatus="activeStatus"
              :statusesCards="cards"
              @activeStatusChanged="changeActiveStatus"
          />
        </v-card>
          <applications-filter @search="search" v-if="!isAdmin"
          />
        <template v-loading="isLoading">
          <applications
              :waitingToBeSentApplications="waitingToBeSentApplications"
              :inReviewApplications="inReviewApplications"
              :pendingApplications="pendingApplications"
              :approvedApplications="approvedApplications"
              :activeStatus="activeStatus"
              :applications="all"
              :totalPages="totalPages"
          />
        </template>
        <div>
          <v-layout
              v-if="totalPages"
              justify-center
              align-center
          >
            <v-pagination class="align-self-center"
                          color="teal darken-4"
                          v-model="page"
                          @input="handlePageChange"
                          :length="totalPages"
                          total-visible="5"
                          circle
            />
          </v-layout>
        </div>
      </v-tab-item>

      <!-- Intimações -->
      <v-tab-item>
        <subpoenas
            :isAdmin="isAdmin"
            @amount="totalSubpoenas"
        />
      </v-tab-item>

      <!-- Auto de Infração -->
      <v-tab-item>
        <infraction
            :isAdmin="isAdmin"
            @amount="newInfractions"
        />
      </v-tab-item>

      <!-- Defesa Auto de Infração -->
      <v-tab-item>
        <infraction-notices
            :isAdmin="isAdmin"
            @amount="newInfractionNotices"
        />
      </v-tab-item>

      <!-- Boletos -->
      <v-tab-item>
        <payment-slips
            :isAdmin="isAdmin"
            @amount="pendingPaymentSlips"
        />
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import Applications from '@/components/application/list/Applications';
import ApplicationsHeader from '@/components/application/list/ApplicationsHeader';
import Subpoenas from '@/components/tabs/Subpoenas';
import InfractionNotices from '@/components/tabs/InfractionNotices';
import Infraction from '@/components/tabs/Infraction';
import PaymentSlips from '@/components/tabs/PaymentSlips';
import ApplicationsFilter from "@/components/application/list/ApplicationsFilter";

export default {
  name: 'Lists',
  components: {
    Applications,
    ApplicationsHeader,
    ApplicationsFilter,
    Subpoenas,
    InfractionNotices,
    PaymentSlips,
    Infraction
  },
  data() {
    return {
      activeStatus: 'all',
      isLoading: true,
      subpoenas: 0,
      paymentSlips: 0,
      infractionNotices: 0,
      infractions: 0,
      total_filtered: 0,
      page: 1,
      per_page: 10
    };
  },
  mounted() {
    this.refreshPage();
  },
  methods: {
    refreshPage(status=""){
      this.$store.dispatch('setLoadingDialog', true);
      const isAdmin = this.$router.currentRoute.meta.userAlias === 'admin';
      if (isAdmin) {
        this.fetchAdminApplications(10, this.page, status);
      }  else {
        this.fetchApplications(10, this.page, status);
      }
      this.$store.dispatch('getCurrentUser');
    },
    search(search){
      this.$store.dispatch('setLoadingDialog', true);
      const isAdmin = this.$router.currentRoute.meta.userAlias === 'admin';
      if (isAdmin) {
        // this.searchAdminApplications(10, this.page, this.activeStatus, search);
      }  else {
        this.searchApplications(10, this.page, search);
      }
      this.$store.dispatch('getCurrentUser');
    },
    changeActiveStatus(status) {
      this.activeStatus = status;
      this.refreshPage(this.activeStatus);
    },
    fetchApplications(per_page = 10,page = 1, status, search) {
      this.$store.dispatch('fetchApplications',{per_page: per_page, page: page, status: status})
        .finally(() => {
          this.isLoading = false;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    fetchAdminApplications(per_page = 10,page = 1, status) {
      this.$store.dispatch('adminFetchApplications', {per_page: per_page, page: page, status: status})
        .finally(() => {
          this.isLoading = false;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    searchApplications(per_page = 10,page = 1,  search) {
      this.$store.dispatch('searchApplications',{per_page: per_page, page: page, search: search})
        .finally(() => {
          this.isLoading = false;
          this.activeStatus = search.status;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    totalSubpoenas(value) {
      this.subpoenas = value;
    },
    pendingPaymentSlips(value) {
      this.paymentSlips = value;
    },
    newInfractionNotices(value) {
      this.infractionNotices = value;
    },
    newInfractions(value) {
      this.infractions = value;
    },
    handlePageChange(newPage) {
      this.page = newPage;
      this.refreshPage(this.activeStatus);
    }
  },
  computed: {
    applications() {
      if (this.$store.getters.applications) {
        return this.$store.getters.applications;
      }
      return null;
    },
    cards() {
      if (this.$store.getters.applications) {
        return this.$store.getters.applications.cards;
      }
      return null;
    },
    all() {
      if (this.applications) {
        return this.applications.applications.filter(application => !application.intimated);
      }
      return null;
    },
    totalPages() {
      if (this.applications) {
        return this.applications.total_pages;
      }
      return null;
    },
    waitingToBeSentApplications() {
      if(this.all){
        return this.all.filter(application => application.status === 'waiting_to_be_sent');
      }
      return null;
    },
    inReviewApplications() {
      if(this.all){
        return this.all.filter(application => application.status === 'waiting_for_review');
      }
      return null;
    },
    pendingApplications() {
      if(this.all){
        return this.all.filter(application => application.status === 'pending');
      }
      return null;
    },
    approvedApplications() {
      if(this.all){
        return this.all.filter(application => application.status === 'done');
      }
      return null;
    },
    user() {
      return this.$store.getters.currentUser;
    },
    isAdmin() {
      return this.$store.getters.currentUser.user_type === 'Admin';
    },
  },
};
</script>
